import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getConsumerAdressTypes = createAsyncThunk(
  '/getConsumerAdressTypes',
  async () => {
    const response = await axios.get('/GetConsumerAddressTypes');
    return response.data;
  }
);

export const getConsumerAdressTypeDetails = createAsyncThunk(
  '/getConsumerAdressTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetConsumerAdressTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const consumerAdressSlice = createSlice({
  name: 'consumerAdress',
  initialState: {
    loading: false,
    error: '',
    consumerAdressTypes: [],
    consumerAdressTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.consumerAdressTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getConsumerAdressTypes.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerAdressTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerAdressTypes.fulfilled]: (state, action) => {
      state.consumerAdressTypes = action.payload;
      state.loading = false;
    },
    [getConsumerAdressTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerAdressTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerAdressTypeDetails.fulfilled]: (state, action) => {
      state.consumerAdressTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.consumerAdressTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const consumerAdressActions = consumerAdressSlice.actions;

export default consumerAdressSlice;
